export default __webpack_public_path__ + "static/media/leetcode.6971d830.svg";